import { render } from "./Description.vue?vue&type=template&id=113a5f4d&scoped=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=113a5f4d&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-113a5f4d"

export default script